import { css as _css } from "@emotion/core";
import React from 'react';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { BedIcon, BathIcon, ParkingIcon, EerIcon, PhotoIcon, CalendarMonthOutlineIcon } from '@domain-group/fe-co-icon';
import { AllhomesListingBadges } from '@domain-group/fe-co-allhomes-listing-badges';
import AllhomesListingCardMediaStats from '../search-result-card/components/allhomes-listing-card-media-stats';
var NoListingImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-listing-card/static/no-listing-image-v2_30dde712.svg";
import * as styles from './default-listing-card-v2.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var renderFeature = (SelectedIcon, value) => value ? ___EmotionJSX("span", {
  css: styles.feature
}, SelectedIcon && ___EmotionJSX("span", null, ___EmotionJSX(SelectedIcon, {
  css: styles.featureIcon
})), ___EmotionJSX("span", {
  css: styles.featureValue
}, value)) : null;
var AgencyBranding = _ref => {
  var _agents$, _agents$2;
  var logo = _ref.logo,
    _ref$colour = _ref.colour,
    colour = _ref$colour === void 0 ? 'transparent' : _ref$colour,
    name = _ref.name,
    agents = _ref.agents;
  return ___EmotionJSX("div", {
    css: styles.agencyBranding({
      backgroundColour: colour
    })
  }, ___EmotionJSX("img", {
    css: styles.agencyLogo,
    src: logo,
    alt: "Logo of ".concat(name)
  }), agents && agents.length > 0 && ___EmotionJSX("div", {
    css: styles.agentContainer
  }, ___EmotionJSX("div", {
    css: styles.agentNames(colour)
  }, agents.map(agent => agent.name).join(' and ')), ___EmotionJSX("div", {
    css: styles.avatarContainer
  }, ___EmotionJSX(Avatar, {
    css: styles.avatar,
    imageUrl: agents && (((_agents$ = agents[0]) === null || _agents$ === void 0 ? void 0 : _agents$.image) || undefined),
    imageTitle: agents && (((_agents$2 = agents[0]) === null || _agents$2 === void 0 ? void 0 : _agents$2.name) || undefined)
  }))));
};
var NextInspection = _ref2 => {
  var date = _ref2.date;
  return ___EmotionJSX("div", {
    css: styles.nextInspection
  }, ___EmotionJSX(CalendarMonthOutlineIcon, {
    css: styles.calendarIcon
  }), moment(date).format('ddd D MMM h:mma'));
};
export var DefaultListingCardV2 = _ref3 => {
  var _ref3$appearance = _ref3.appearance,
    appearance = _ref3$appearance === void 0 ? 'vertical' : _ref3$appearance,
    _ref3$noBorderRadius = _ref3.noBorderRadius,
    noBorderRadius = _ref3$noBorderRadius === void 0 ? false : _ref3$noBorderRadius,
    _ref3$noBorder = _ref3.noBorder,
    noBorder = _ref3$noBorder === void 0 ? false : _ref3$noBorder,
    cardUrl = _ref3.cardUrl,
    imageUrl = _ref3.imageUrl,
    propertyDetails = _ref3.propertyDetails,
    showAgencyBranding = _ref3.showAgencyBranding,
    agencyDetails = _ref3.agencyDetails,
    _ref3$badges = _ref3.badges,
    badges = _ref3$badges === void 0 ? [] : _ref3$badges,
    nextInspection = _ref3.nextInspection,
    buttonComponent = _ref3.buttonComponent,
    extraContent = _ref3.extraContent,
    galleryLabel = _ref3.galleryLabel,
    className = _ref3.className,
    onClick = _ref3.onClick,
    annotations = _ref3.annotations,
    hasVideo = _ref3.hasVideo,
    has3dTour = _ref3.has3dTour,
    bottomRightComponent = _ref3.bottomRightComponent;
  var title = propertyDetails.title,
    line1 = propertyDetails.line1,
    line2 = propertyDetails.line2,
    bedrooms = propertyDetails.bedrooms,
    bathrooms = propertyDetails.bathrooms,
    parking = propertyDetails.parking,
    eer = propertyDetails.eer,
    propertyType = propertyDetails.propertyType;
  var image = imageUrl || NoListingImage;
  var agencyBrandingIsPresent = Boolean(showAgencyBranding && (agencyDetails === null || agencyDetails === void 0 ? void 0 : agencyDetails.agencyLogo));
  var showNextInspection = Boolean(nextInspection);
  var showExtraContent = !showNextInspection && Boolean(extraContent);
  var divider = '•';
  return ___EmotionJSX("div", {
    className: className,
    css: styles.listingCard({
      appearance,
      noBorderRadius,
      noBorder
    })
  }, ___EmotionJSX("div", {
    css: styles.imageContainer({
      appearance,
      noBorderRadius
    })
  }, ___EmotionJSX("img", {
    css: styles.image({
      appearance,
      hasImage: !!imageUrl
    }),
    src: image,
    alt: ""
  }), appearance === 'vertical' && agencyBrandingIsPresent && ___EmotionJSX(AgencyBranding, {
    logo: agencyDetails === null || agencyDetails === void 0 ? void 0 : agencyDetails.agencyLogo,
    colour: agencyDetails === null || agencyDetails === void 0 ? void 0 : agencyDetails.agencyBrandingColour,
    name: agencyDetails === null || agencyDetails === void 0 ? void 0 : agencyDetails.name,
    agents: agencyDetails === null || agencyDetails === void 0 ? void 0 : agencyDetails.agents
  }), ___EmotionJSX("div", {
    css: styles.top
  }, ___EmotionJSX("div", {
    css: styles.badges
  }, isEmpty(annotations) ? badges.slice(0, 2).map(badge => ___EmotionJSX("div", {
    key: badge.label,
    css: styles.badge({
      bgColour: badge.colour
    })
  }, badge.label)) : ___EmotionJSX(AllhomesListingBadges, {
    annotations: annotations,
    labelType: "short"
  })), galleryLabel && ___EmotionJSX("div", {
    css: styles.galleryBadge
  }, ___EmotionJSX(PhotoIcon, {
    size: "small"
  }), ___EmotionJSX("span", null, galleryLabel)), (hasVideo || has3dTour) && ___EmotionJSX(AllhomesListingCardMediaStats, {
    css: styles.mediaStats,
    hasVideo: hasVideo,
    has3dTour: has3dTour
  })), !showAgencyBranding && bottomRightComponent && ___EmotionJSX("div", {
    css: styles.bottomRightComponent
  }, bottomRightComponent)), ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX("div", {
    css: styles.defaultContent
  }, ___EmotionJSX("div", {
    css: styles.details
  }, ___EmotionJSX("div", {
    css: styles.title
  }, ___EmotionJSX("a", {
    css: /*#__PURE__*/_css([styles.cardLink, onClick && styles.hover]),
    href: cardUrl !== null && cardUrl !== void 0 ? cardUrl : undefined,
    onClick: onClick
  }, title)), ___EmotionJSX("div", {
    css: styles.line12
  }, line1), line2 && ___EmotionJSX("div", {
    css: styles.line12
  }, line2), ___EmotionJSX("div", {
    css: styles.features
  }, renderFeature(BedIcon, bedrooms), renderFeature(BathIcon, bathrooms), renderFeature(ParkingIcon, parking), eer ? renderFeature(EerIcon, eer.toFixed(1)) : null, bedrooms || bathrooms || parking || eer ? propertyType && ___EmotionJSX("span", null, divider) : null, renderFeature(null, propertyType))), buttonComponent && ___EmotionJSX("div", {
    css: styles.button
  }, buttonComponent)), showExtraContent && ___EmotionJSX("div", {
    css: styles.extraContent
  }, extraContent), showNextInspection && ___EmotionJSX("div", {
    css: styles.extraContent
  }, ___EmotionJSX(NextInspection, {
    date: nextInspection === null || nextInspection === void 0 ? void 0 : nextInspection.startTime
  }))));
};